import { render, staticRenderFns } from "./BoUploader.vue?vue&type=template&id=0d07f56e&"
import script from "./BoUploader.vue?vue&type=script&lang=js&"
export * from "./BoUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports